"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerFieldValidation = exports.setFormError = exports.setFieldValue = exports.isFormDirty = exports.getFieldValue = exports.clearFieldError = exports.Form = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHookForm = require("react-hook-form");
var _yup = require("@hookform/resolvers/yup");
var yup = _interopRequireWildcard(require("yup"));
var _Button = require("../Button");
var _lodash = require("lodash");
var _ToolTip = _interopRequireDefault(require("../ToolTip"));
var _Icon = require("../Icon");
var _hideFilterIcon = require("../../svgs/hide-filter-icon");
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let setFormError = () => {};
exports.setFormError = setFormError;
let setFieldValue = () => {};
exports.setFieldValue = setFieldValue;
let getFieldValue = () => {};
exports.getFieldValue = getFieldValue;
let clearFieldError = () => {};
exports.clearFieldError = clearFieldError;
let triggerFieldValidation = () => {};
exports.triggerFieldValidation = triggerFieldValidation;
let isFormDirty = () => false;
exports.isFormDirty = isFormDirty;
const Form = props => {
  const {
    defaultValues,
    children,
    onSubmit,
    hideShowButton,
    validationSchema,
    validationSchemaDependencies = [],
    submitButtonText = "Submit",
    redirectUrl = "#",
    globalError,
    disableSubmit,
    tooltipTitle,
    displayTooltip,
    watchFields = [""],
    isUserAuthenticated,
    mode = "onSubmit",
    submitOnCancel = false,
    submitButtonStyle = "primary",
    cancelButtonText = "Cancel",
    cancelButtonStyle = "secondary",
    canCelButtonCallback
  } = props;
  const schema = yup.object().shape(validationSchema, validationSchemaDependencies);
  const {
    watch,
    handleSubmit,
    control,
    reset,
    setValue,
    setFocus,
    getValues,
    setError,
    clearErrors,
    trigger,
    formState: {
      errors
    }
  } = (0, _reactHookForm.useForm)({
    defaultValues,
    resolver: (0, _yup.yupResolver)(schema),
    mode: mode
  });
  exports.setFormError = setFormError = setError;
  exports.setFieldValue = setFieldValue = setValue;
  exports.getFieldValue = getFieldValue = getValues;
  exports.clearFieldError = clearFieldError = clearErrors;
  exports.triggerFieldValidation = triggerFieldValidation = trigger;
  const count = object => Object.values(object).filter(item => item).length;
  const [filterCount, setFilterCount] = (0, _react.useState)(count(getValues()));
  const [isFilterHidden, toggleFilterSection] = (0, _react.useState)(false);
  const isFormValuesDirty = () => {
    return !(0, _lodash.isEqual)(getValues(), defaultValues);
  };
  exports.isFormDirty = isFormDirty = isFormValuesDirty;
  (0, _react.useEffect)(() => {
    const handleBeforeUnloadEvent = e => {
      if (isFormValuesDirty() && isUserAuthenticated() === "true") {
        e.preventDefault();
        e.returnValue = "Are you sure you want to leave?";
        return "Are you sure you want to leave?";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnloadEvent);
    return () => {
      exports.isFormDirty = isFormDirty = () => false;
      window.removeEventListener("beforeunload", handleBeforeUnloadEvent);
    };
  }, []);
  const returnFormControl = child => {
    const {
      name
    } = child.props;
    return name ? /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
      render: _ref => {
        let {
          field
        } = _ref;
        return /*#__PURE__*/_react.default.createElement(child.type, {
          ...{
            ...field,
            ...child.props,
            setValue,
            getValues,
            errors,
            setFocus,
            ref: ref => {
              field.ref({
                focus: setFocus
              });
            }
          }
        });
      },
      control: control,
      name: name,
      defaultValue: defaultValues ? defaultValues[name] : "",
      key: name
    }) : child;
  };
  const redirecToParent = () => {
    const {
      history
    } = props;
    if (history) {
      history.push(redirectUrl);
    }
  };
  const handleCancel = async () => {
    if (submitOnCancel) {
      reset(defaultValues);
      onSubmit(defaultValues);
    } else if (canCelButtonCallback) {
      canCelButtonCallback();
    } else {
      redirecToParent();
    }
  };
  const hideShowFilter = () => /*#__PURE__*/_react.default.createElement("div", {
    className: "reset__wrapper"
  }, /*#__PURE__*/_react.default.createElement(_ToolTip.default, {
    text: isFilterHidden ? "Show filters" : "Hide filters"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hideButton",
    id: "hide-filter",
    onClick: () => toggleFilterSection(!isFilterHidden)
  }, isFilterHidden && /*#__PURE__*/_react.default.createElement("span", null, filterCount, " filter", filterCount > 1 ? "s" : "", " "), /*#__PURE__*/_react.default.createElement(_hideFilterIcon.HideFilterIcon, null))));
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      e.stopPropagation();
      handleSubmit(onSubmit)(e);
    },
    className: (0, _classnames.default)({
      "hide-filter": isFilterHidden
    }, "form__wrapper")
  }, Array.isArray(children) ? children.map(child => {
    const {
      isDynamicForm,
      getDynamicFormSize,
      isDisableButton
    } = child.props;
    if (isDynamicForm) {
      const {
        name,
        addLabel
      } = child.props;
      let {
        children,
        className
      } = child.props;
      children = Array.isArray(children) ? children : [children];
      const {
        fields,
        append,
        remove
      } = (0, _reactHookForm.useFieldArray)({
        control,
        name: name
      });
      const watchFieldArray = watch(name);
      const controlledFields = fields.map((field, index) => {
        return {
          ...field,
          ...watchFieldArray[index]
        };
      });
      if (getDynamicFormSize) {
        getDynamicFormSize(controlledFields === null || controlledFields === void 0 ? void 0 : controlledFields.length);
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, controlledFields.map((field, index) => {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: className ? "dynamic__form--wrapper ".concat(className) : "dynamic__form--wrapper"
        }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: field.id
        }, children.map(childItem => returnFormControl( /*#__PURE__*/_react.default.cloneElement(childItem, {
          name: "".concat(name, ".").concat(index, ".").concat(childItem.props.name),
          ref: ref => {
            field.ref({
              focus: setFocus
            });
          }
        }))), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
          icon: ["fas", "minus-circle"],
          size: "1x",
          className: "remove-button-wrap",
          onClick: () => remove(index)
        })));
      }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
        disabled: isDisableButton,
        type: "button",
        outline: true,
        color: "".concat(isDisableButton ? "secondary" : "primary"),
        className: "add-button-wrap add-button-wrap-".concat(controlledFields === null || controlledFields === void 0 ? void 0 : controlledFields.length),
        buttontext: addLabel,
        onClick: e => {
          e.preventDefault();
          let appendList = {};
          children.map(childItem => {
            const {
              defaultValue
            } = childItem.props;
            appendList[childItem.props.name] = defaultValue || "";
          });
          append(appendList);
        }
      }));
    }
    return returnFormControl(child);
  }) : returnFormControl(children), /*#__PURE__*/_react.default.createElement("div", {
    className: "form--button__wrapper"
  }, /*#__PURE__*/_react.default.createElement(_ToolTip.default, {
    disabled: !Object.keys(errors).length && !globalError && disableSubmit,
    text: !displayTooltip && !hideShowButton ? tooltipTitle : ""
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    type: "submit",
    id: "disablebtnTooltip",
    buttontext: submitButtonText,
    color: submitButtonStyle,
    disabled: !Object.keys(errors).length && !globalError && disableSubmit
  })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    buttontext: cancelButtonText,
    color: cancelButtonStyle,
    onClick: handleCancel,
    className: "cancel--reset-button"
  })), isFilterHidden && /*#__PURE__*/_react.default.createElement("span", {
    className: "required__symbol"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "asterisk"
  }, "*"), "Required"), globalError && /*#__PURE__*/_react.default.createElement("p", {
    className: "form-group is-invalid"
  }, "Something went wrong! Please try again later.")), hideShowButton && hideShowFilter());
};
exports.Form = Form;
Form.propTypes = {
  defaultValues: _propTypes.default.object,
  onSubmit: _propTypes.default.func,
  redirectUrl: _propTypes.default.string,
  validationSchema: _propTypes.default.object,
  submitButtonText: _propTypes.default.string,
  isUserAuthenticated: _propTypes.default.func
};